// store/usePullToRefreshStore.ts — Lets the currently-mounted screen register
// an extra refresh callback for screens that fetch data outside react-query
// (so PullToRefresh in PageShell can call it alongside invalidateQueries).

import { create } from 'zustand';

type RefreshHandler = () => Promise<void> | void;

interface PullToRefreshState {
  handler: RefreshHandler | null;
  setHandler: (handler: RefreshHandler | null) => void;
}

export const usePullToRefreshStore = create<PullToRefreshState>()((set) => ({
  handler: null,
  setHandler: (handler) => set({ handler }),
}));
